var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['ui segment', { inverted: _vm.theme }],style:(_vm.segmentStyle)},[_c('div',{class:_vm.titleClass},[_c('i',{class:_vm.iconClass}),_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }